import * as React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

import * as plume from '@ulule/owl-kit-components/next'
import * as url from '@boutique/url'
import * as cold from '@owl-nest/cold-data/client'

export function Breadcrumbs(): React.ReactElement {
  const {
    query: { category, hierarchy, q: fullTextSearch },
  } = useRouter()

  const pageUrl = url.products({
    currentTree: cold.getTree(cold.hierarchy, hierarchy ? String(hierarchy) : undefined),
    title: getTitle({
      fullTextSearch: typeof fullTextSearch === 'string' ? fullTextSearch : undefined,
      category: CATEGORIES.find(({ slug }) => slug === category)?.name,
    }),
  })

  return (
    <plume.Breadcrumbs
      crumbs={pageUrl.crumbs}
      LinkComponent={({ href, children }) => <Link href={href}>{children}</Link>}
    />
  )
}

function getTitle({
  fullTextSearch,
  category,
}: {
  fullTextSearch: string | undefined
  category: string | undefined
}): string {
  if (fullTextSearch) {
    return 'Recherche'
  } else {
    if (category) {
      return category
    } else {
      return `Nos produits`
    }
  }
}

const CATEGORIES = cold.types['category'].flatMap((slug) =>
  cold.taxonomies[slug].children.tags.map((tagSlug) => {
    const tag = cold.tags[tagSlug]
    return {
      name: tag.name,
      slug: tag.slug,
    }
  }),
)
